module.exports = __webpack_public_path__ + "img/coordinate.5f9a6960.png";